import { Component, inject, input } from '@angular/core';
import { CdkMenu, CdkMenuItem, CdkMenuTrigger } from '@angular/cdk/menu';
import { NavItem } from '../nav-item.model';
import { TranslatePipe } from '@ngx-translate/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { UserPreferencesFacade } from '@app/core/stores/user-preferences';

@Component({
  selector: 'topo-nav-item-hover-menu',
  imports: [CdkMenu, CdkMenuItem, CdkMenuTrigger, TranslatePipe, RouterLink, RouterLinkActive],
  templateUrl: './nav-item-hover-menu.component.html',
  styleUrl: './nav-item-hover-menu.component.scss',
})
export class NavItemHoverMenuComponent {
  protected isDarkMode = inject(UserPreferencesFacade).isDarkTheme;
  navItem = input.required<NavItem>();
  protected timeoutFn: NodeJS.Timeout;

  mouseEnter(trigger: CdkMenuTrigger) {
    if (!!this.timeoutFn) {
      clearTimeout(this.timeoutFn);
    }
    trigger.open();
  }

  mouseLeave(trigger: CdkMenuTrigger) {
    this.timeoutFn = setTimeout(() => {
      trigger.close();
    }, 50);
  }
}
